<script>
  import { onMount } from "svelte";
  export let path;
  export let loop = false;
  export let autoplay = true;
  export let style = "";
  export let eventListeners = [];
  
  let elem;
  let anim;

  export const play = () => anim.play();
  export const pause = () => anim.pause();

  const registerEvents= (eventListeners) => {
    eventListeners.forEach((eventListener) => {
      anim.addEventListener(
        eventListener.eventName,
        eventListener.callback
      );
    });
  }

  onMount(() => {
    anim = lottie.loadAnimation({
      container: elem,
      path: path,
      renderer: "svg",
      loop: loop,
      autoplay: autoplay
    });

    registerEvents(eventListeners);
  });
</script>

<div
  style={style}
  bind:this={elem}
></div>